/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1CourseregistrationEnrollmentCourseregistrationidDetailsTabQueryResponse,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidDetailsTabPathParams,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidDetailsTab400,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidDetailsTab401,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidDetailsTab500,
} from "../../types/courseRegistrationEnrollmentController/GetApiV1CourseregistrationEnrollmentCourseregistrationidDetailsTab.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1CourseregistrationEnrollmentCourseregistrationidDetailsTab } from "../../clients/courseRegistrationEnrollmentController/getApiV1CourseregistrationEnrollmentCourseregistrationidDetailsTab.ts";

export const getApiV1CourseregistrationEnrollmentCourseregistrationidDetailsTabQueryKey =
  (
    courseRegistrationId: GetApiV1CourseregistrationEnrollmentCourseregistrationidDetailsTabPathParams["courseRegistrationId"],
  ) =>
    [
      {
        url: "/api/v1/courseregistration/enrollment/:courseRegistrationId/details-tab",
        params: { courseRegistrationId: courseRegistrationId },
      },
    ] as const;

export type GetApiV1CourseregistrationEnrollmentCourseregistrationidDetailsTabQueryKey =
  ReturnType<
    typeof getApiV1CourseregistrationEnrollmentCourseregistrationidDetailsTabQueryKey
  >;

export function getApiV1CourseregistrationEnrollmentCourseregistrationidDetailsTabQueryOptions(
  courseRegistrationId: GetApiV1CourseregistrationEnrollmentCourseregistrationidDetailsTabPathParams["courseRegistrationId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey =
    getApiV1CourseregistrationEnrollmentCourseregistrationidDetailsTabQueryKey(
      courseRegistrationId,
    );
  return queryOptions<
    GetApiV1CourseregistrationEnrollmentCourseregistrationidDetailsTabQueryResponse,
    ResponseErrorConfig<
      | GetApiV1CourseregistrationEnrollmentCourseregistrationidDetailsTab400
      | GetApiV1CourseregistrationEnrollmentCourseregistrationidDetailsTab401
      | GetApiV1CourseregistrationEnrollmentCourseregistrationidDetailsTab500
    >,
    GetApiV1CourseregistrationEnrollmentCourseregistrationidDetailsTabQueryResponse,
    typeof queryKey
  >({
    enabled: !!courseRegistrationId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1CourseregistrationEnrollmentCourseregistrationidDetailsTab(
        courseRegistrationId,
        { ...config, signal: config.signal ?? signal },
      );
    },
  });
}

/**
 * @description Retorna dados cadastrais, de curso, polo, status e documentação de uma matrícula para exibição na aba Detalhes do gerenciamento. **(Requer Authorization para autenticação)**
 * @summary Retorna os detalhes de uma matrícula (Requer Authorization para autenticação)
 * {@link /api/v1/courseregistration/enrollment/:courseRegistrationId/details-tab}
 */
export function useGetApiV1CourseregistrationEnrollmentCourseregistrationidDetailsTab<
  TData =
    GetApiV1CourseregistrationEnrollmentCourseregistrationidDetailsTabQueryResponse,
  TQueryData =
    GetApiV1CourseregistrationEnrollmentCourseregistrationidDetailsTabQueryResponse,
  TQueryKey extends QueryKey =
    GetApiV1CourseregistrationEnrollmentCourseregistrationidDetailsTabQueryKey,
>(
  courseRegistrationId: GetApiV1CourseregistrationEnrollmentCourseregistrationidDetailsTabPathParams["courseRegistrationId"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1CourseregistrationEnrollmentCourseregistrationidDetailsTabQueryResponse,
        ResponseErrorConfig<
          | GetApiV1CourseregistrationEnrollmentCourseregistrationidDetailsTab400
          | GetApiV1CourseregistrationEnrollmentCourseregistrationidDetailsTab401
          | GetApiV1CourseregistrationEnrollmentCourseregistrationidDetailsTab500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1CourseregistrationEnrollmentCourseregistrationidDetailsTabQueryKey(
      courseRegistrationId,
    );

  const query = useQuery(
    {
      ...getApiV1CourseregistrationEnrollmentCourseregistrationidDetailsTabQueryOptions(
        courseRegistrationId,
        config,
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1CourseregistrationEnrollmentCourseregistrationidDetailsTab400
      | GetApiV1CourseregistrationEnrollmentCourseregistrationidDetailsTab401
      | GetApiV1CourseregistrationEnrollmentCourseregistrationidDetailsTab500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
